import { render } from "./ArticleComponent.vue?vue&type=template&id=7c1d9fe3"
import script from "./ArticleComponent.vue?vue&type=script&lang=js"
export * from "./ArticleComponent.vue?vue&type=script&lang=js"

import "./ArticleComponent.vue?vue&type=style&index=0&id=7c1d9fe3&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__